<template>
    <iv-modal
        :title="title"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
    >
    <iv-form
      :ref="FORM_NAME"
      :model="sources.formData"
      label-position="top"
      inline
      :rules="options_validation.validation.formData"
      style="display: flex">
      <iv-form-item label="行业：" prop="industryId" style="width: 200px">
          <iv-select v-model="sources.formData.industryId" @on-change="onIndustryId">
              <iv-option v-for="item in options.industry" :key="item.id" :value="item.id">
                  {{ item.name }}
              </iv-option>
          </iv-select>
      </iv-form-item>
      <iv-form-item label="公司：" prop="stockCode" style="flex-grow: 1">
          <CompanySelect
            filterable
            transfer
            placeholder="选择公司"
            sourceType="company"
            :params="options.company.conditions"
            :value="options.company.value"
            @change="onCompanyChange"
            style="width:100%"
          />
      </iv-form-item>
      <iv-form-item label="项目年：" prop="year" style="width: 120px">
          <iv-select v-model="sources.formData.year" @on-change="refreshSecondTarget">
              <iv-option v-for="item in options.year" :key="item.id" :value="item.id">
                  {{ item.name }}
              </iv-option>
          </iv-select>
      </iv-form-item>
    </iv-form>
    <hr class="adm-hr" style="margin-bottom: 2em;">
    <div v-if="type == 'create'" v-for="(sentiment, i) in sources.formData.sentimentList"
    :key="i">
            <SentimentItem
                :i="i"
                :sentimentList="sources.formData.sentimentList"
                :secondTargetList="secondTargetList"
                :value="sentiment"
                @handleRemove="handleRemove"
                @handleAdd="handleAdd"
                @handleFormData="handleFormData">
            </SentimentItem>
    </div>
    <div v-else>
      <iv-form
        ref="sentiment"
        :model="sources.formData"
        label-position="left"
        :label-width="75"
        :inline="false"
      >
        <iv-form-item label="舆情标题：" prop="title">
            <iv-input v-model="sources.formData.title"></iv-input>
        </iv-form-item>
        <iv-form-item label="链接" prop="url">
            <iv-input v-model="sources.formData.url" placeholder="完整链接，如：http://www.baidu.com/"></iv-input>
        </iv-form-item>
        <iv-form-item label="关联指标：" prop="secondTargetNum">
            <iv-select v-model="sources.formData.secondTargetNum">
              <iv-option v-for="(item, i) in secondTargetList" :key="i" :value="item.secondTargetNum">
                  {{ item.secondTargetName }}
              </iv-option>
            </iv-select>
        </iv-form-item>
        <iv-form-item label="数量" prop="number">
            <iv-input v-model="sources.formData.number"></iv-input>
        </iv-form-item>
      </iv-form>
    </div>
    <div slot="footer" style="float: left;line-height:3;">备注：标题内容建议按“地点”+“事件”的形式录入以方便日后排查
    </div>
    <iv-button type="text" size="large" slot="footer" @click="onCancel">取消</iv-button>
    <iv-button :loading="loader[NEGATIVE_SENTIMENT]" type="primary" size="large" slot="footer" @click="onSuccess">保存</iv-button>
    </iv-modal>
</template>
<script>
import Vue from "vue";
import { BusinessError, RequestError, isNumber, getProductYear,years} from '@/utils/';
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import NegativeSentimentModel from "@/models/NegativeSentimentModel";
import TargetModel from "@/models/TargetModel";
import IndustryModel from '@/models/IndustryModel'
import CompanyModel    from '@/models/CompanyModel'

import SentimentItem from '@/components/SentimentItem'
import CompanySelect from "@/components/CompanySelect"

const _years = years().map(year=>({...year, title:year.name}))

const NEGATIVE_SENTIMENT = NegativeSentimentModel.ModelName;
const TARGET = TargetModel.ModelName;
const INDUSTRY = IndustryModel.ModelName;
const COMPANY = CompanyModel.ModelName;

const FORM_NAME = `${NEGATIVE_SENTIMENT}Form`;
var validation  = () => {
    return {
        industryId: [
            { required: true, type: 'number', message: '请选择行业', trigger: 'change' }
        ],
        stockCode: [
            { required: true, type: 'string', message: '请选择公司', trigger: 'change' }
        ],
        year: [
            { required: true, type: 'number', message: '请选择年份', trigger: 'change' }
        ]
    }
};

export default {
    mixins: [
        LoaderMixin(
          NEGATIVE_SENTIMENT,
          TARGET,
          INDUSTRY,
          COMPANY
        ),
        ModelMixin({
            contact,
            models: [
              NegativeSentimentModel,
              TargetModel,
              IndustryModel,
              CompanyModel
            ],
        }),
    ],
    props: {
        width: {
            type: [String, Number],
            default: "500",
        },
        value: {
            type: Object,
            default: null,
        },
        rules: {
            type: Object,
            default: null,
        },
        title: String,
        type: {
            type: String,
            default:"create"
        },
        shown: Boolean,
    },
    watch: {
        shown(val) {
            this.sources.shown = val;
        },
        value(val){
            if(!val) return;
            this.sources.formData.industryId = Number(val.industryId)
            this.sources.formData.year = val.year
            this.sources.formData.stockCode = val.stockCode
            this.sources.formData.title = val.title
            this.sources.formData.url = val.url
            this.sources.formData.secondTargetNum = val.secondTargetNum
            this.sources.formData.number = val.number

            this.options.company.value = [val.stockCode]

            this.refreshSecondTarget()
        },
        ['sources.formData.industryId'](val){
          this.options.company.conditions.industryId = val
        }
    },
    data() {
        return {
            FORM_NAME,
            NEGATIVE_SENTIMENT,
            TARGET,
            INDUSTRY,
            COMPANY,
            options_validation: {
                validation: {
                    formData: validation()
                },
            },
            sources: {
                shown: false,
                formData: {
                    industryId:"",
                    year:getProductYear(),
                    stockCode:"",
                    sentimentList:[
                        { title: "", url:"", secondTargetNum:"", validation:false, number: 1}
                    ],
                    title:"",
                    url:"",
                    secondTargetNum:""
                },
            },
            secondTargetList:[],
            options:{
              year: _years,
              industry:[],
              company: {
                conditions: {
                  abbreviation: "",
                  industryId: "",
                  type: ""
                },
                list:[],
                value: [],
                pagination: {
                  page:1,
                  total:0,
                  limit:10,
                  offset:0
                }
              },
            }
        };
    },
    mounted(){
        this.refreshSecondTarget()
        this.refreshIndustry()
    },
    methods: {
        async refreshIndustry(params = this.$route.params){
            const industry = await this.$$fetch(INDUSTRY,params)
            if(industry)  this.options.industry = industry.data.map(item=>({...item,name:item.industry}))
            return this.options.industry
        },
        onCompanyChange(checkedList){
          const [value] = this.sources.formData.stockCode = checkedList
          this.sources.formData.stockCode = value
        },
        handleAdd(i) {
            this.sources.formData.sentimentList.push({ title: "", url:"", secondTargetNum:"", validation:false,  number: 1});
        },
        handleRemove(value){
            const { item,i } =value
            this.sources.formData.sentimentList.splice(i,1)
        },
        handleFormData(value){
            const { formData,i } = value
            this.sources.formData.sentimentList.splice(i,1,formData)
        },
        handleClose(event, name) {
            const index = this.tagsList.indexOf(name);
            this.tagsList.splice(index, 1);
        },
        onCancel() {
            this.hide();
        },
        async onSuccess(){
            const validate = await this.$refs[FORM_NAME].validate();
            if (!validate) {
                this.$$warning('表单验证不通过，请继续填写。');
                return Promise.reject(new Error('表单验证不通过，请继续填写。'));
            }
            switch(this.type){
                case 'create':
                    this.$$loading(NEGATIVE_SENTIMENT)
                    const result_create = await this.$$active(NEGATIVE_SENTIMENT, 'createNegativeSentiment',
                    this.sources.formData)
                    if ([BusinessError, RequestError, Error].indexOf(result_create.constructor) == -1){
                      this.hide()
                      this.$$success("新建成功！")
                    }
                    this.$$loaded(NEGATIVE_SENTIMENT)
                    break;
                case 'edit':
                    this.$$loading(NEGATIVE_SENTIMENT)
                    const result_edit = await this.$$active(NEGATIVE_SENTIMENT, 'saveNegativeSentiment',
                    { ...this.sources.formData, id: this.value.id })
                    if ([BusinessError, RequestError, Error].indexOf(result_edit.constructor) == -1){
                      this.hide()
                      this.$$success("修改成功！")
                    }
                    this.$$loaded(NEGATIVE_SENTIMENT)
                    break;
            }
        },
        hide() {
            this.sources.shown = false;
            this.$refs[FORM_NAME].resetFields();
            this.$emit("shown-changed", this.sources.shown);
             this.sources.formData =  {
                industryId:"",
                year:getProductYear(),
                stockCode:"",
                sentimentList:[
                    { title: "", url:"", secondTargetNum:"", validation:false, number: 1}
                ],
                title:"",
                url:"",
                secondTargetNum:""
            }
            this.options.company.conditions.abbreviation = ""
            this.options.company.value = []
            // this.$emit("refresh");
        },
        async refreshSecondTarget(query){
            var result = await this.$$active(TARGET, 'sentiment',{
                industryId: this.sources.formData.industryId ,
                year:this.sources.formData.year
            })
            this.secondTargetList = result.data
        },
        onIndustryId(){
          this.refreshSecondTarget()
          this.sources.formData.stockCode = ""
          this.options.company.conditions.abbreviation = ""
          this.options.company.value = []
        }
    },
    components:{
        SentimentItem,
        CompanySelect
    }
};
</script>
<style scoped>
.ivu-tag {
    margin: 5px;
}
.panelList {
    list-style: none;
    padding: 18px 15px;
    font-size: 14px;
    line-height: 28px;
}
.radio-button {
    font-size: 15px;
    border-radius: 5px !important;
}
.addInput {
    margin: 5px;
    display: inline-block;
}

</style>
